module.exports = __webpack_public_path__ + "img/NE.6e160500.svg";